<div mat-dialog-content>
        <p>{{data.question}}</p>
</div>
<div mat-dialog-actions align="center">
        <button mat-button (click)="onNoClick()">{{data.leftButtonText}}</button>
        <button color="primary" mat-button (click)="onOkClick()" cdkFocusInitial>{{data.rightButtonText}}</button>
</div>